import dayjs from 'dayjs';

/**
 *
 * @param startDate - The starting date
 * @param endDate - The ending date
 * @returns The number of months between the two dates
 */
export function monthsBetween(startDate: Date | string, endDate: Date | string): number {
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  return Math.abs(end.diff(start, 'month'));
}
/**
 * Converts a total number of months into a years and months 
 * @param totalMonths - The total number of months to convert
 * @returns A formatted string of years and months

 */
export const convertMonthsToYearsAndMonths = (totalMonths: number): string => {
  if (isNaN(totalMonths) || totalMonths < 0) {
    return '';
  }

  // Calculate years and remaining months
  const years: number = Math.floor(totalMonths / 12);
  const months: number = totalMonths % 12;

  const yearText: string = years === 1 ? 'year' : 'years';
  const monthText: string = months === 1 ? 'month' : 'months';

  // Handle special cases for cleaner output
  if (years === 0) {
    return `${months} ${monthText}`;
  } else if (months === 0) {
    return `${years} ${yearText}`;
  }
  return `${years} ${yearText}, ${months} ${monthText}`;
};

/*
 * Formats a date string from MM/DD/YYYY to "Day Month DD YYYY" format
 * @param {string} dateString - Date string in MM/DD/YYYY format
 * @returns {string} Formatted date string
 */
export const formatDate = (dateString: string) => {
  const date = dayjs(dateString, 'MM/DD/YYYY');
  if (!date.isValid()) {
    throw new Error('Invalid date');
  }

  return date.format('MMM D YYYY');
};

export const getYearsAndMonthsBetween = (startDate: Date | string, endDate: Date | string): { years: number; months: number } => {
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  let fullMonthCount = 0;
  let currentMonth = start.startOf('month');

  // Iterate through each month in the range
  while (currentMonth.isBefore(end) || currentMonth.isSame(end, 'month')) {
    // Calculate the actual start and end dates for this month within the range

    const monthStart = start.isAfter(currentMonth) ? start : currentMonth;
    const monthEnd = end.isBefore(currentMonth.endOf('month')) ? end : currentMonth.endOf('month');

    // Use dayjs diff to calculate days in this month
    const daysInMonth = monthEnd.diff(monthStart, 'day') + 1;

    // Get the total days in this calendar month
    const totalDaysInMonth = currentMonth.daysInMonth();

    // Count as full month if
    // 30+ days
    //complete month (all days of that month)
    const isFullMonth = daysInMonth >= 30 || daysInMonth === totalDaysInMonth;
    if (isFullMonth) {
      fullMonthCount++;
    }

    // Move to next month
    currentMonth = currentMonth.add(1, 'month');
  }

  const years = Math.floor(fullMonthCount / 12);
  const months = fullMonthCount % 12;

  return { years, months };
};

export const todaysDate = new Date().toISOString().split('T')[0];
